import { render } from "./user-user.vue?vue&type=template&id=50b7105b&scoped=true"
import script from "./user-user.vue?vue&type=script&lang=js"
export * from "./user-user.vue?vue&type=script&lang=js"

import "./user-user.vue?vue&type=style&index=0&id=50b7105b&lang=css"
import "./user-user.vue?vue&type=style&index=1&id=50b7105b&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b7105b"]])

export default __exports__